<template>
  <div>
    <b-form-select
      :id="fieldId"
      :class="fieldClass"
      @change="updateSelected(selectedValue)"
      v-model="selectedValue"
      :required="isRequired"
      :name="fieldData.field_name"
      :options="fieldData.settings.allowed_values"
    >
      <template #first>
        <b-form-select-option :value="null" :disabled="isRequired">
          -- Select --
        </b-form-select-option>
      </template>
    </b-form-select>
    <short-text-filter
      v-if="showOther"
      :id="fieldId + '-explain'"
      :label="getExplainLabel"
      :get-value="explainValue"
      class="raft-js-search-add-label"
      :update-method="updateExplain"
      :use-json-api-filter-manager="false"
      ref="explain_field_explain_input"
    />
  </div>
</template>

<script>
import ShortTextFilter from "../filters/ShortTextFilter.vue";

export default {
  name: "ExplainField",
  components: {
    ShortTextFilter,
  },
  data() {
    return {
      selectedValue: null,
      explainValue: "",
    };
  },
  props: {
    // Optional label element value.
    label: {
      type: String,
      default: "",
    },
    fieldId: {
      type: String,
      required: true,
    },
    fieldClass: {
      type: String,
      required: true,
    },
    fieldData: {
      type: Object,
      required: true,
    },
    fieldValue: {
      type: Object || String,
      default: function () {
        return { value: null, explain: "" };
      },
    },
    isRequired: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    colStyle: function () {
      const width = 100 / this.colsPerRow - 0.25;
      return {
        width: width + "%",
        float: "left",
      };
    },
    showOther: function () {
      const explainKey = this.fieldData.settings.explain_key;
      if (explainKey) {
        return explainKey === this.selectedValue;
      }
      return false;
    },
    getExplainLabel: function () {
      const label = this.fieldData.settings.explain_label;
      if (label) {
        return label;
      }
      return "Explain";
    },
  },
  mounted() {
    this.resetData();
  },
  methods: {
    updateSelected(newVal) {
      let explainValue = "";
      if (this.showOther) {
        explainValue = this.explainValue;
      }
      this.$emit("explain-field-update", {
        value: newVal,
        explain: explainValue,
      });
    },
    resetData() {
      if (!this.fieldValue) {
        this.selectedValue = null;
        this.explainValue = "";
        return;
      }
      if (this.fieldValue.hasOwnProperty("value")) {
        this.selectedValue = this.fieldValue.value;
      }
      if (this.fieldValue.hasOwnProperty("explain") && this.showOther) {
        this.explainValue = this.fieldValue.explain;
      }
    },
    updateExplain(newVal) {
      this.$emit("explain-field-update", {
        value: this.selectedValue,
        explain: newVal,
      });
    },
  },
  watch: {
    fieldValue() {
      this.resetData();
    },
  },
};
</script>

<style scoped></style>
